import { SlideIn } from "../../../../SlideIn";

import { colors } from "@indeed/ifl-tokens";

export type AttributeTooltipModalProps = {
  labelClose: string;
  title: string;
  isOpen: boolean;
  content: React.ReactNode;
  onDismiss: () => void;
};

export function AttributeTooltipModal({
  labelClose,
  title,
  isOpen,
  onDismiss,
  content,
}: AttributeTooltipModalProps) {
  return (
    <SlideIn
      isOpen={isOpen}
      onDismiss={onDismiss}
      title={title}
      labelClose={labelClose}
      sx={{ backgroundColor: colors.background["[base]"], flexGrow: 1 }}
    >
      {content}
    </SlideIn>
  );
}
